import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75c52a1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "g-card order-form rule-form" }
const _hoisted_2 = { class: "weui-cells_checkbox form-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "g-checkbox form-subtitle",
  for: "isAgree"
}, " 同意转运规则条约 ", -1))
const _hoisted_4 = ["checked"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "radio weui-icon-checked" }, null, -1))
const _hoisted_6 = { class: "order-content" }
const _hoisted_7 = { class: "agree-rule" }
const _hoisted_8 = { class: "rule-desc" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirm-tips" }, [
  /*#__PURE__*/_createElementVNode("div", null, "*请确保邮寄的线路与所选的一致。"),
  /*#__PURE__*/_createElementVNode("div", null, "寄送过程存在货物测量的差异，导致价格浮动，这是正常现象。")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.isAgree) = $event)),
        type: "checkbox",
        value: true,
        id: "isAgree",
        class: "agree-protocol weui-check",
        checked: _ctx.form.isAgree
      }, null, 8, _hoisted_4), [
        [_vModelCheckbox, _ctx.form.isAgree]
      ]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createTextVNode(" 查看 "),
          _createElementVNode("span", {
            class: "name",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navRule && _ctx.navRule(...args)))
          }, " 《格布转运规则与说明》 ")
        ])
      ]),
      _hoisted_9
    ])
  ]))
}